import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import { jsx as _jsx } from "react/jsx-runtime";
const BusinessUnitWarning = () => /*#__PURE__*/_jsx(UIAlert, {
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "dashboard.businessUnit.warning.title"
  }),
  type: "warning",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "dashboard.businessUnit.warning.description"
  })
});
export default BusinessUnitWarning;